import { computed } from "vue";

// check if domain contains "cms", so cms.verbleif.nl is valid but verbleif.nl/cms is not
export function isCmsContext(): boolean {
  return window.location.hostname.includes("cms");
}

export const isCms = computed(() => isCmsContext());

// check if domain contains "integrations", so integrations.verbleif.nl is valid but verbleif.nl/integrations is not
export function isIntegrationsContext(): boolean {
  return window.location.hostname.includes("integrations");
}

export const isIntegrations = computed(() => isIntegrationsContext());
